module.exports = __webpack_public_path__ + "static/media/great-support.b6918a9f.jpg";